module.exports = __webpack_public_path__ + "static/media/modelo_importacao_puntu.c6b89e20.xlsx";